import { useState } from 'react'
import { DateField } from '@/components/DateField'

/* ---------- helpers ---------- */

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
				{title}
			</h3>
			{children}
		</div>
	)
}

/* ---------- sandbox ---------- */

export function DateFieldSandbox () {
	const [basicValue, setBasicValue] = useState<string | undefined>(undefined)
	const [labeledValue, setLabeledValue] = useState<string | undefined>(undefined)
	const [prefilledValue, setPrefilledValue] = useState<string | undefined>(
		'2026-04-22'
	)

	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── Basic ── */}
			<Section title='Basic'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<DateField value={basicValue} onValueChange={setBasicValue} />
					<span className='spaces:text-12 spaces:text-content-3'>Value: {basicValue ?? '—'}</span>
				</div>
			</Section>

			{/* ── With Label ── */}
			<Section title='With Label'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<DateField
						label='Move-in Date'
						value={labeledValue}
						onValueChange={setLabeledValue}
					/>
					<span className='spaces:text-12 spaces:text-content-3'>
						Value: {labeledValue ?? '—'}
					</span>
				</div>
			</Section>

			{/* ── Pre-filled value ── */}
			<Section title='Pre-filled Value'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<DateField
						label='Lease Start'
						value={prefilledValue}
						onValueChange={setPrefilledValue}
					/>
					<span className='spaces:text-12 spaces:text-content-3'>
						Value: {prefilledValue ?? '—'}
					</span>
				</div>
			</Section>

			{/* ── Disabled ── */}
			<Section title='Disabled'>
				<div className='spaces:w-[280px]'>
					<DateField label='Move-in Date' value='2026-06-01' disabled />
				</div>
			</Section>
		</div>
	)
}
